export enum PermissionGroupMessages {
  generalRegistration = "permissionGroup.generalRegistration",
  supply = "permissionGroup.supply",
  concreteRecipeFamily = "permissionGroup.concreteRecipeFamily",
  administration = "permissionGroup.administration",
  supplyQuality = "permissionGroup.supplyQuality",
  vehicles = "permissionGroup.vehicles",
  employees = "permissionGroup.employees",
  report = "permissionGroup.report",
  settings = "permissionGroup.settings",
  expedition = "permissionGroup.expedition",
  schedule = "permissionGroup.schedule",
  userRightsControl = "permissionGroup.userRightsControl",
  batchPortalMaintenanceView = "permissionGroup.batchPortalMaintenanceView",
  batchPortalMaintenanceEdit = "permissionGroup.batchPortalMaintenanceEdit",
  batchPortalMaintenanceExecute = "permissionGroup.batchPortalMaintenanceExecute",
  batchPortalAutomationView = "permissionGroup.batchPortalAutomationView",
  batchPortalAutomationExecute = "permissionGroup.batchPortalAutomationExecute",
  batchPortalAutomationAdmin = "permissionGroup.batchPortalAutomationAdmin",
  batchPortalAutomationSuperAdmin = "permissionGroup.batchPortalAutomationSuperAdmin",
  dashboard = "permissionGroup.dashboard",
  laboratory = "permissionGroup.laboratory",
}

export type TranslationPermissionGroupMessages = {
  [key in PermissionGroupMessages]: string;
}